
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import logoImg from '@/assets/logo/logo.png'
import variables from '@/assets/styles/variables.scss'

export default defineComponent({
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    
    const title = ref(process.env.VUE_APP_TITLE || '')
    const logo = ref(logoImg)
    
    const sideTheme = computed(() => store.state.settings.sideTheme)
    
    return {
      title,
      logo,
      sideTheme,
      variables
    }
  }
})
